import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import FastClick from 'fastclick'
import moment from 'moment'
import './utils/rem'
import './style/global.less'
import YxpIcon from '@/components/common/YxpIcon'

if(location.origin==='http://rc-air.mfy777.com'){
  location.href='https://rc-air.mfy777.com'+location.pathname+location.hash;
}

if(location.origin==='http://air.mfy777.com'){
  location.href='https://air.mfy777.com'+location.pathname+location.hash;
}

FastClick.attach(document.body);

import Dialog from './components/common/Dialog/dialog.js'
import Toast from './components/common/Toast/toast.js'
import * as filters from './utils/vue-filter.js'
import {
  Button,
  Drawer,
  Icon,
  Modal,
  message,
  notification
} from 'ant-design-vue';

Vue.prototype.$message = message;
Vue.prototype.$modal = Modal;
Vue.prototype.$notification = notification;

Vue.use(Button)
  .use(Drawer)
  .use(Icon)
  .use(Dialog)
  .use(Toast)
  .use(YxpIcon)
Vue.config.productionTip = false
Vue.config.silent = true

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})
moment.locale('zh-cn');   
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
